/** H4: nothing translated yet. Shown under the grid that holds the "nouveau texte" card alone. */
export function HistoriqueVide() {
  return (
    <p className="mt-6 font-light text-body text-gray-700 leading-[1.55]">
      Aucune traduction pour l'instant : vos textes traduits apparaîtront ici, pour que vous
      puissiez rouvrir leur résultat à tout moment.
    </p>
  );
}
